export const LOGIN_URL = "/admin/login";
export const GET_USER_LIST = "/admin/users";
export const GET_DASH_BOARD = "/admin/dashboard";
export const GET_USER_DETAILS = "/admin/user";
export const GET_CATEGORIES = "/category/all";
export const DELETE_CETEGORY = "/category/delete";
export const UPDATE_CATEGORY = "/category/update";
export const CREATED_CATEGORY = "/category/create";
export const GET_REPORT = "/report";
export const DELETE_REPORT = "/report/delete-report";
export const DELETE_CONTENT = "/delete";
export const GET_POST = "/admin/post/";
export const GET_STORIES = "/admin/story/all";
export const GET_BLOGS="/admin/blog/all";
export const GET_POST_DETAILS = "/posts";
export const GET_STORY_DETAILS = "/story";
export const GET_BLOG_DETAILS = "/blog";
export const CHANGE_PASSWORD = "/users/change-password";
export const GETBLOG_CATEGORY = "/blog/category";
export const GETSTORY_CETEGORY = "/story/category";
export const GET_FEEDBACK = "/feedback";
